<template>
  <section>
    <div class="columns">
      <div class="column">
        <sc-card>
          <div slot="body">
            <div class="columns">
              <div class="column">
                <h1 class="subtitle has-text-weight-bold has-text-primary is-size-4">
                  {{delivery.name}}
                </h1>
              </div>
              <div class="column">
                <div class="remove-div">
                  <sc-button
                    icon="times"
                    theme="danger"
                    @click="removeContract(delivery)"
                    class="button-add"/>
                </div>
              </div>
            </div>
            <sc-contract :contract="delivery" />
          </div>
        </sc-card>
      </div>
    </div>
  </section>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

import {
  ScCard,
  ScButton,
} from '@intelipost-js/secure-components';
import ScContract from '../sc-contract/ScContract';

const {
  mapMutations,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-logistic-contracts',
  props: {
    delivery: Object,
  },
  components: {
    ScCard,
    ScButton,
    ScContract,
  },
  methods: {
    ...mapMutations([
      'deleteContract',
      'deleteContractId',
    ]),
    removeContract(contract) {
      this.deleteContract({ contract });
      this.deleteContractId({ contract });
    },
  },
};
</script>
<style lang="scss" scoped>
.button-add {
  margin-top: 29px;
 }
 .column-times {
   text-align: right;
 }
 .remove-div {
    text-align: right;
 }
 .remove-div button{
   margin-top: 0px;
 }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-logistic-contracts/ScLogisticContratcs.vue?2c3a1ace